import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './ModelViewer.css';

function Chest() {
  const navigate = useNavigate();
  const modelRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleBack = () => {
    navigate('/menu');
  };

  useEffect(() => {
    const mv = modelRef.current;
    if (!mv) return;

    const handleLoad = () => setIsLoading(false);
    mv.addEventListener('load', handleLoad);

    // Failsafe
    const timeout = setTimeout(() => setIsLoading(false), 10000);

    return () => {
      mv.removeEventListener('load', handleLoad);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="model-viewer-page skeleton-page">
      <button onClick={handleBack} className="back-btn">← Back to Menu</button>

      {isLoading && (
        <div className="skeleton-mv-loading">
          <div className="skeleton-loading-spinner"></div>
          <p>Loading 3D Chest...</p>
        </div>
      )}

      <model-viewer
        ref={modelRef}
        src="/models/chest.glb"
        alt="3D Chest Model"
        ar
        ar-modes="webxr scene-viewer quick-look"
        camera-controls
        touch-action="none"
        shadow-intensity="1"
        loading="eager"
        reveal="auto"
        interaction-prompt="none"
        quick-look-browsers="safari chrome"
        camera-orbit="0deg 75deg 2m"
        max-camera-orbit="auto auto 4m"
        field-of-view="45deg"
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#ffffff',
          '--progress-bar-color': '#00E5FF',
          '--progress-bar-height': '4px',
        }}
      ></model-viewer>
    </div>
  );
}

export default Chest;
